import { Select } from '@radix-ui/themes'
import {
  incrementMinuteSelection,
  isoTimeRegex,
} from '@Components/util/increment-minute-selection.tsx'

export const TimeSelector = ({
  startTime,
  endTime,
  minuteIncrements,
  selectedTime,
  onValueChange,
  disabled,
  className,
}: {
  startTime: string
  endTime: string
  minuteIncrements: string[]
  selectedTime: string | undefined
  onValueChange: (v: string) => void
  disabled: boolean
  className?: string
}) => {
  if (!(isoTimeRegex.test(startTime) && isoTimeRegex.test(endTime))) {
    throw new Error(
      `Start time and end time must be valid ISO times of the format HH:MM:SS, got ${startTime} and ${endTime}`,
    )
  }

  const [_startHour, startMinute] = startTime.split(':')
  const [_startMinute, endMinute] = endTime.split(':')

  if (!(minuteIncrements.includes(startMinute) && minuteIncrements.includes(endMinute))) {
    throw new Error(
      `Start time and end time must be exactly on one of the specified minute increments provided`,
    )
  }

  function getDisplayTime(isoTime: string): string {
    const [hour, minute] = isoTime.split(':')
    let displayHour = hour
    let meridian = 'AM'
    const numericHour = parseInt(hour)
    if (numericHour >= 12) {
      if (numericHour > 12) {
        displayHour = (numericHour - 12).toString()
      }
      meridian = 'PM'
    }

    return `${displayHour}:${minute} ${meridian}`
  }

  const timeValues: string[] = []
  let currentTime = startTime
  while (currentTime <= endTime) {
    timeValues.push(currentTime)
    currentTime = incrementMinuteSelection(currentTime, minuteIncrements)
  }

  return (
    <Select.Root defaultValue={selectedTime} onValueChange={onValueChange} disabled={disabled}>
      <Select.Trigger className={className} />
      <Select.Content>
        {timeValues.map((time) => {
          return (
            <Select.Item key={time} value={time}>
              {getDisplayTime(time)}
            </Select.Item>
          )
        })}
      </Select.Content>
    </Select.Root>
  )
}
